/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "EnumerableMap__IndexOutOfBounds",
        type: "error",
    },
    {
        inputs: [],
        name: "EnumerableMap__NonExistentKey",
        type: "error",
    },
];
const _bytecode = "0x60808060405234601757603a9081601d823930815050f35b600080fdfe600080fdfea2646970667358221220f0578eb12aa54b0343fdd16ca64f600cc314744ec97f048915658cb7cc34c23664736f6c63430008140033";
const isSuperArgs = (xs) => xs.length > 1;
export class EnumerableMap__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
EnumerableMap__factory.bytecode = _bytecode;
EnumerableMap__factory.abi = _abi;
